import { render } from "./About.vue?vue&type=template&id=5cf43adf"
const script = {}
script.render = render

export default script